/**
 * Formats a phone number for display as (XXX) XXX-XXXX.
 * Falls back to showing the raw value unchanged if it isn't a standard
 * 10-digit US number (e.g. partial input, international numbers, extensions).
 */
export const formatPhoneNumber = (phone?: string | null): string => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');

  if (digits.length === 10) {
    return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
  }
  if (digits.length === 11 && digits.startsWith('1')) {
    const d = digits.slice(1);
    return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  }

  return phone;
};
